import React, { useState, useEffect } from 'react';

import { Menu, X, Globe, ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const { currentLanguage, changeLanguage, t } = useLanguage();

  const languages = [
    { code: 'EN', name: 'English' },
    { code: 'HI', name: 'हिंदी' },
    { code: 'GU', name: 'ગુજરાતી' },
    { code: 'MR', name: 'मराठी' },
    { code: 'BN', name: 'বাংলা' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const handleLanguageChange = (language) => {
    changeLanguage(language.code);
    setShowLanguageDropdown(false);
  };

  const handleLoginClick = () => {
    // Redirect to admin panel
    window.location.href = '/admin';
  };

  const navItems = [
    { name: t('nav.funding_options'), href: '#funding' },
    { name: t('nav.how_it_works'), href: '#how-it-works' },
    { name: t('nav.about_us'), href: '#about' },
    { name: t('nav.blog'), href: '#blog' },
    { name: t('nav.faq'), href: '#faq' }
  ];

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">

        {/* Logo */}
        <div className="navbar-logo">
          <a href="#home" onClick={closeMenu}>
            <img
              className="navbar-logo-img"
              src="/vikas1.ico"
              alt="Vikas Fund"
            />
          </a>
        </div>

        {/* Desktop Navigation */}

        <div className="navbar-menu desktop-menu">
          {navItems.map((item, index) => (
            <a
              key={index}
              href={item.href}
              className="nav-link"
              onClick={closeMenu}
            >
              {item.name}
            </a>
          ))}
        </div>

        {/* Language Selector and Login */}
        <div className="navbar-actions">
          {/* Language Selector */}
          <div className="language-selector">
            <button
              className="language-btn"
              onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
            >
              <Globe size={18} />
              <span>{currentLanguage}</span>
              <ChevronDown size={16} />
            </button>
            
            {showLanguageDropdown && (
              <div className="language-dropdown">
                {languages.map((language) => (
                  <button
                    key={language.code}
                    className={`language-option ${
                      currentLanguage === language.code ? 'active' : ''
                    }`}
                    onClick={() => handleLanguageChange(language)}
                  >
                    {language.name}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Login Button */}
          <button className="login-btn" onClick={handleLoginClick}>
            {t('nav.login')}
          </button>
        </div>

        {/* Mobile Menu Button */}
        <div className="mobile-menu-btn">
          <button onClick={toggleMenu} className="menu-toggle">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        <div className="mobile-nav-items">
          {navItems.map((item, index) => (
            <a
              key={index}
              href={item.href}
              className="mobile-nav-link"
              onClick={closeMenu}
            >
              {item.name}
            </a>
          ))}
          
          {/* Mobile Language Selector */}
          <div className="mobile-language-selector">
            <div className="mobile-language-label">{t('nav.language')}</div>
            <div className="mobile-language-options">
              {languages.map((language) => (
                <button
                  key={language.code}
                  className={`mobile-language-option ${
                    currentLanguage === language.code ? 'active' : ''
                  }`}
                  onClick={() => handleLanguageChange(language)}
                >
                  {language.name}
                </button>
              ))}
            </div>
          </div>

          {/* Mobile Login Button */}
          <button className="mobile-login-btn" onClick={handleLoginClick}>
            {t('nav.login')}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 